(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recently-viewed"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const recentlyViewedProductsSection = document.querySelector('.recently-viewed-products');
    const currentProductScript = document.querySelector('script[data-recently-viewed-products]');
    const swiperContainer = document.querySelector('.recently-viewed-products-swiper');
    const cardMarkupElement = document.querySelector('.card-markup');

    if (!cardMarkupElement) {
      return;
    }

    const cardMarkup = cardMarkupElement.innerHTML;
    cardMarkupElement.remove();

    let currentProduct = null,
      recentlyViewedProducts = [];
    if (!currentProductScript) {
      return;
    }
    try {
      currentProduct = JSON.parse(currentProductScript.innerHTML);
    } catch (e) {
      console.error('Error parsing current product:', e);
    }

    if (!currentProduct) {
      return;
    }

    const localStorageKey = 'recently_viewed';

    function money(cents, zeros = false) {
      //convert cents to dollars
      const dollars = cents / 100;
      if (zeros) {
        return `$${dollars.toFixed(2)} USD`;
      }
      return `$${dollars.toFixed(0)} USD`;
    }

    function getRecentlyViewedProducts() {
      let recentlyViewed = [];
      try {
        recentlyViewed = JSON.parse(localStorage.getItem(localStorageKey)) || [];
      } catch (e) {
        console.error('Error parsing recently viewed products:', e);
        localStorage.removeItem(localStorageKey);
      }
      return recentlyViewed;
    }

    function setRecentlyViewedProduct(handle) {
      let recentlyViewed = getRecentlyViewedProducts();
      recentlyViewed = recentlyViewed.filter((product) => product.handle !== currentProduct.handle);
      recentlyViewed.unshift(currentProduct);
      //limit to 10 recent products, if there are more than 10, remove the extras
      if (recentlyViewed.length > 10) {
        recentlyViewed = recentlyViewed.slice(0, 10);
      }
      localStorage.setItem(localStorageKey, JSON.stringify(recentlyViewed));

      recentlyViewedProducts = recentlyViewed;
    }

    function renderRecentlyViewedProducts() {
      let recentlyViewed = recentlyViewedProducts.length ? recentlyViewedProducts : getRecentlyViewedProducts();
      recentlyViewed = recentlyViewed.filter((product) => product.handle !== currentProduct.handle);

      if (!recentlyViewed.length) {
        return;
      }

      swiperContainer.innerHTML = '';

      recentlyViewed.forEach((product) => {
        //create an element from the card markup we can use to render the product
        const cardElement = document.createElement('div');
        cardElement.innerHTML = cardMarkup;

        const cardLinkElement = cardElement.querySelector('a');
        const titleElement = cardElement.querySelector('[data-title]');
        const priceElement = cardElement.querySelector('.price');
        const imageContainerElement = cardElement.querySelector('.image-container');
        const missingImageElement = cardElement.querySelector('[data-missing-image]');
        const primaryImageElement = cardElement.querySelector('.primary-image');
        const secondaryImageElement = cardElement.querySelector('.secondary-image');
        const priceVaries = product.price_min !== product.price_max;

        if (primaryImageElement) {
          primaryImageElement.remove();
        }

        if (secondaryImageElement) {
          secondaryImageElement.remove();
        }

        if (product.image && product.image !== 'null' && product.image !== 'undefined') {
          const imageHolder = document.createElement('div');
          imageHolder.innerHTML = product.image;
          const newImage = imageHolder.querySelector('img');
          if (product.second_image && product.second_image !== 'null' && product.second_image !== 'undefined') {
            const secondImageHolder = document.createElement('div');
            secondImageHolder.innerHTML = product.second_image;
            const secondNewImage = secondImageHolder.querySelector('img');
            if (secondNewImage) {
              imageContainerElement.prepend(secondNewImage);
            }
          }
          if (newImage) {
            imageContainerElement.prepend(newImage);
            missingImageElement.classList.add('hidden');
          } else {
            missingImageElement.classList.remove('hidden');
          }
        } else {
          missingImageElement.classList.remove('hidden');
        }

        titleElement.innerHTML = `<a class="text-dark-900 hover:text-primary-900" href="${product.url}">${product.title}</a>`;
        cardLinkElement.href = product.url;

        if (priceVaries) {
          if (priceElement) {
            priceElement.innerHTML = `<span class="inline-block text-sm">Starting at <span>${money(
              product.price_min,
              false
            )}</span></span>`;
          }
        } else {
          if (priceElement) {
            
            priceElement.innerHTML = '';
            const priceSpan = document.createElement('span');
            priceSpan.classList.add('inline-block');

            if (product.compare_at_price && product.compare_at_price > product.price) {
              priceSpan.classList.add('text-success-700', 'font-bold', 'text-sm');
            }
            priceSpan.innerHTML = `${money(product.price, false)}`;
            priceElement.appendChild(priceSpan);
          }

          if (product.compare_at_price && product.compare_at_price > product.price) {
            const compareAtPriceSpan = document.createElement('span');
            compareAtPriceSpan.classList.add('line-through', 'text-dark-500', 'ms-1', 'inline-block', 'text-xs');
            compareAtPriceSpan.innerHTML = `${money(product.compare_at_price, false)}`;
            if (priceElement) {
              priceElement.appendChild(compareAtPriceSpan);
            }
          }
        }

        //create a new swiper-slide element
        const swiperSlideElement = document.createElement('swiper-slide');
        cardElement.classList.add('pb-8');
        swiperSlideElement.appendChild(cardElement);
        swiperContainer.appendChild(swiperSlideElement);
      });

      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        scrollbar: {
          draggable: true,
        },
        breakpoints: {
          1024: {
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      };
      Object.assign(swiperContainer, swiperConfig);
      recentlyViewedProductsSection.classList.remove('hidden');
      swiperContainer.initialize();
    }
    setRecentlyViewedProduct();
    renderRecentlyViewedProducts();
  });

  } catch(e) { console.error(e); }
})();
})();
